import { render } from "./Index.vue?vue&type=template&id=1f2ca47a&bindings={\"teaching_classrooms\":\"props\",\"learning_classrooms\":\"props\",\"flash\":\"props\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1f2ca47a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f2ca47a')) {
    api.reload('1f2ca47a', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=1f2ca47a&bindings={\"teaching_classrooms\":\"props\",\"learning_classrooms\":\"props\",\"flash\":\"props\"}", () => {
    api.rerender('1f2ca47a', render)
  })

}

script.__file = "resources/js/Pages/AssignedClassrooms/Index.vue"

export default script